import { Component } from '@angular/core';
import { take, catchError } from 'rxjs/operators';
import { ProductGroup } from 'src/app/order/models/product-group.model';
import { ProductGroupService } from '../../services/product-group.service';
import { ProductGroupValidatorService } from '../../validators/product-group-validator.service';

@Component({
    selector: 'app-product-groups-new',
    templateUrl: './product-groups-new.component.html',
    styleUrls: ['./product-groups-new.component.scss'],
    standalone: false
})
export class ProductGroupsNewComponent {

  productGroup: ProductGroup = new ProductGroup();

  isError: boolean = false;
  isServerError: boolean = false;

  constructor(private productGroupValidator: ProductGroupValidatorService,
    private productGroupService: ProductGroupService) { }

  onSubmit() {

    this.isError = false;
    this.isServerError = false;

    if (this.productGroupValidator.isValid(this.productGroup)) {
      this.productGroupService.createProductGroup(this.productGroup)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        return e;
      }))
      .subscribe(() => {
        window.location.href = '/warehousing/product-groups';
      })
    } else {
      this.isError = true;
    }
  }
}
